import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=1ed26069&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=1ed26069&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed26069",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed26069')) {
      api.createRecord('1ed26069', component.options)
    } else {
      api.reload('1ed26069', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=1ed26069&scoped=true", function () {
      api.rerender('1ed26069', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/previewFrom/preview.vue"
export default component.exports